import axios from "axios";
import React, { useEffect, useState } from "react";
import { deleteRealEstate, getAllProjects, getAllRealEstate } from "../../services/api.service";
import toasterService from "../toast/ToasterService.component";

const URL = "https://jsonplaceholder.typicode.com/users";

const RealEstateTable = () => {
  const [data, setData] = useState<any>([]);
  const getData = async () => {
    const response = await getAllRealEstate();
    console.log(response);
    setData(response);
  };

  const ctaDeleteRealEstateHandler = async (id: any) => {
    try {
      console.log(`ctaDeleteRealEstateHandler =>`);
      const sure = window.confirm("Are you sure?");
      console.log(sure);
      if (!sure) {
        toasterService.set({
          title: "Empty Field!",
          message: `[Empty Field] Error While Adding a new Project`,
          type: "error",
          toastSize: "toastSmall",
        });
        return false;
      }
      const response = await deleteRealEstate(id);
      console.log(response);
      if (response) {
        getData();
        toasterService.set({
          title: "Success!",
          message: `Successfully deleted a realState.`,
          type: "success",
          toastSize: "toastSmall",
        });
      } else {
        toasterService.set({
          title: "Failed!",
          message: `Faliure.`,
          type: "error",
          toastSize: "toastSmall",
        });
      }
    } catch (error) {
      console.log(error);
    }
  };
  const renderHeader = () => {
    let headerElement = ["id", "name", "operation"];

    return headerElement.map((key, index) => {
      return <th key={index}>{key.toUpperCase()}</th>;
    });
  };
  useEffect(() => {
    getData();

    return () => {};
  }, []);

  return (
    <div className='table'>
      <table id='employee'>
        <thead>
          <tr>{renderHeader()}</tr>
        </thead>
        <tbody>
          {data.length >= 1 &&
            data.map(({ _id, title }: any, index: number) => {
              console.log(_id);
              return (
                <tr key={_id}>
                  <td>{index + 1}</td>
                  <td>{title}</td>
                  <td className='operation'>
                    <button
                      className='button'
                      onClick={() => {
                        ctaDeleteRealEstateHandler(_id);
                      }}>
                      Delete
                    </button>
                  </td>
                </tr>
              );
            })}
        </tbody>
      </table>
    </div>
  );
};

export default RealEstateTable;
